export enum LoginFormState {
    FillIn, FillInPassword, Login, Send, Error, Validating
}
